import { Modal } from 'antd';
import BookingForm from '../Booking/BookingForm';


const BookingModal = ({ isModalOpen, onClose }) => {

  return (
    <>
      <Modal
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onCancel={onClose}
        // onOk={handleOk}
        width={1000}
        footer={null}
      >
        <BookingForm onClose={onClose}/>
      </Modal>
    </>
  );
};
export default BookingModal;